export const navigation_admin = [
  {
    id: "maketplaces",
    title: "Marketplace",
    type: "item",
    url: "/main/marketplace/all"
  }
];
